import styled from 'styled-components';

export const QuestWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	border: 1px solid transparent;
	transition:
		transform 0.3s ease,
		border 0.3s ease;
	height: 100%;

	&:hover {
		transform: scale(1.02);
		border: 1px solid ${({ theme }) => theme.colors.transparent.light30};
	}
`;

export const QuestImage = styled.img<{ src: string }>`
	height: 136px;
	object-fit: contain;
	margin: 8px;
`;

export const QuestReward = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 20px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};
	padding: 0 16px;
	margin-bottom: 6px;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.colors.icon.main};

		rect {
			fill: ${({ theme }) => theme.colors.icon.main};
		}
	}
`;

export const QuestRewardIcon = styled.img`
	width: 24px;
	height: 24px;
`;

export const QuestInfo = styled.div`
	margin-top: 6px;
	padding: 0 16px;
`;

export const QuestName = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};
	margin-bottom: 8px;
`;

export const QuestDescription = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
	line-height: 1.2;
	margin-bottom: 6px;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	overflow: hidden;
	text-overflow: ellipsis;

	p {
		font-size: 14px;
		font-weight: 400;
		color: ${({ theme }) => theme.colors.text.body};
		line-height: 1.2;
	}

	a {
		display: none;
	}

	p:last-child {
		display: none;
	}
`;

export const Divider = styled.div`
	height: 1px;
	background-color: ${({ theme }) => theme.colors.transparent.light15};
	width: 100%;
`;

export const QuestButtons = styled.div`
	display: flex;
	gap: 8px;
	padding: 0 16px;
	margin-bottom: 16px;
	justify-content: end;
`;
